/* eslint-disable @typescript-eslint/naming-convention */
// default format values

export const FORMAT = {
  DATE: "MM/DD/YYYY",
  DATE_TIME: "MM/DD/YYYY HH:mm",
};
